import select from './src/select';

export default select;


// WEBPACK FOOTER //
// ./src/components/select/index.js